import React from 'react';
import { Box, Typography, Container, Paper, Button, styled } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3, 5),
  borderRadius: '20px',
  textAlign: 'center',
  background: 'linear-gradient(145deg, #ffffff 0%, #fefefe 100%)',
  border: '2px solid #ffebee',
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3)
  }
}));

const StyledErrorIcon = styled(ErrorOutlineIcon)({
  fontSize: '100px',
  color: '#f44336',
  marginBottom: '16px',
  filter: 'drop-shadow(0 4px 8px rgba(244, 67, 54, 0.3))'
});

const StyledPrimaryButton = styled(Button)(({ theme }) => ({
  padding: theme.spacing(1.5, 4),
  fontSize: '1.1rem',
  borderRadius: '10px',
  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
    transform: 'translateY(-1px)'
  }
}));


const DonationError: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <StyledPaper elevation={6}>
        <Box sx={{ mb: 3 }}>
          <StyledErrorIcon />
        </Box>

        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            color: '#d32f2f',
            fontWeight: 'bold',
            mb: 2,
            fontSize: { xs: '1.8rem', md: '2.5rem' }
          }}
        >
          ⚠️ Bağış İşlemi Tamamlanamadı
        </Typography>

        <Typography
          variant="h6"
          sx={{
            mb: 3,
            color: '#c62828',
            fontWeight: 500,
            fontSize: { xs: '1.1rem', md: '1.3rem' }
          }}
        >
          Üzgünüz, işlem sırasında bir sorun yaşandı
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap', mt: 4 }}>
          <StyledPrimaryButton
            variant="contained"
            color="primary"
            size="large"
            href="/"
            startIcon={<RefreshIcon />}
          >
            Tekrar Dene
          </StyledPrimaryButton>
        </Box>
      </StyledPaper>
    </Container>
  );
};

export default DonationError;
